import React from "react";
import * as FaIcons from "react-icons/fa";
import { DataGenieIcon, DistressedIcon, ExpiredsIcon, FsboIcon, NeighborhoodSearchIcon, PreforeclosureIcon, OldExpiredsIcon } from "src/components/icons";

export interface SidebarItem {
  title: string;
  path: string;
  icon: React.ReactNode;
  cName: string;
  activePattern?: string;
  window?: boolean;
  featureFlag?: string;
}

export const coreProducts: SidebarItem[] = [
  {
    title: "Expireds",
    path: "/expireds",
    icon: <ExpiredsIcon />,
    cName: "nav-text",
  },
  {
    title: "FSBO",
    path: "/fsbo",
    icon: <FsboIcon />,
    cName: "nav-text",
  },
  {
    title: "Pre-Foreclosure",
    path: "/Preforeclosure",
    icon: <PreforeclosureIcon />,
    cName: "nav-text",
  },
  {
    title: "Neighborhood Search",
    path: "/ns/search",
    icon: <NeighborhoodSearchIcon />,
    cName: "nav-text",
    activePattern: "/ns",
  },
  {
    title: "Scripts",
    path: "/scripts",
    icon: <FaIcons.FaFile />,
    cName: "nav-text",
    window: false,
  },
  {
    title: "Tutorials & Training",
    path: "/tutorials",
    icon: <FaIcons.FaGraduationCap />,
    cName: "nav-text",
    featureFlag: "REACT_APP_ENABLE_TUTORIALS_PAGE",
  },
];

export const filterByFeatureFlag = (items: SidebarItem[]): SidebarItem[] => {
  return items.filter((item) => {
    if (!item.featureFlag) return true;
    return process.env[item.featureFlag] === "true";
  });
};

export const addOns: SidebarItem[] = [
  {
    title: "Data Genie",
    path: "/data-genie",
    icon: <DataGenieIcon style={{ fontSize: "19px" }} />,
    cName: "nav-text",
  },
  {
    title: "Distressed",
    path: "/Distressed",
    icon: <DistressedIcon />,
    cName: "nav-text",
  },
  {
    title: "Old Expired",
    path: "/OldExpired",
    icon: <OldExpiredsIcon />,
    cName: "nav-text",
    window: false,
  },
  {
    title: "Call Capture",
    path: "https://callcapture.landvoice.com/account/dashboard",
    icon: <FaIcons.FaPhone />,
    cName: "nav-text",
    window: true,
  }
];
